<template>
    <section>
        <!-- 查询栏 -->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form :inline="true" :model="filters" style="float: right;" @submit.native.prevent>
				<el-form-item>
					<el-input v-model="filters.shopname"  @keyup.enter.native="getShop" placeholder="门店名称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="getShop" icon="el-icon-search">查询汇总信息</el-button>
				</el-form-item>
				<!-- <el-form-item>
					<el-button type="primary" @click="handleAdd">新增门店</el-button>
				</el-form-item> -->
			</el-form>
		</el-col>
        	<!--列表-->
		<el-table :data="shoplist" show-summary  highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<!-- <el-table-column prop="Id" width="120" label="门店ID" >
			</el-table-column> -->
			<el-table-column prop="Name" label="门店名称 " width="150" sortable>
			</el-table-column>
			<el-table-column prop="Count" label="剩余短信" width="120" sortable>
			</el-table-column>
			<!-- <el-table-column prop="UnitPrice" label="短信单价" width="120" sortable>
			</el-table-column> -->
			<el-table-column prop="UsageAmount" label="已使用量" width="120" sortable>
			</el-table-column>	
            <el-table-column prop="Balance" label="充值金额" width="120" sortable>
			</el-table-column>
            <el-table-column prop="CancelLog" label="撤销次数" width="120" sortable>
			</el-table-column>       
            <el-table-column prop="RechargeCount" label="充值总数" width="120" sortable>
			</el-table-column>
            <el-table-column prop="RechargeLog" label="充值次数" width="120" sortable>
			</el-table-column>
            <el-table-column prop="Sum" label="消费金额" min-width="180" sortable>
			</el-table-column>		
              <el-table-column label="操作" width="350" >
				<template  slot-scope="scope">
					<!-- <el-button type="success" size="small" @click="editorShow(scope.row)">门店简介</el-button> -->
					<el-button type="warning" size="small" @click="handleRecharge(scope.$index, scope.row)">充值</el-button>
					<el-button type="primary" size="small" @click="rechargeLog(scope.$index, scope.row)">查看充值记录</el-button>
				</template>
			</el-table-column>
		</el-table>
        <!--工具条-->			
		<!-- <el-col :span="24" class="toolbar">
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10" :total="total" style="float:right;">
			</el-pagination>
		</el-col> -->  

		        <!-- 充值界面 -->
	<el-dialog title="短信充值" v-model="RechargeFormVisible" :close-on-click-modal="false">
			<el-form :model="RechargeForm" label-width="100px" :rules="RechargeFormRules" ref="RechargeForm">
				<el-form-item label="充值数量" prop="Count">
					<el-input v-model.number="RechargeForm.Count" auto-complete="off" @change="Count()"></el-input>
				</el-form-item>
				<el-form-item label="充值单价" prop="UnitPrice">
					<el-input v-model.number="RechargeForm.UnitPrice" auto-complete="off" @change="UnitPrice()"></el-input>
				</el-form-item>
				<el-form-item label="充值金额" prop="Money" >
					<el-input  v-model.number="RechargeForm.Money" auto-complete="off" ></el-input>
				</el-form-item>
				
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="RechargeFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="RechargeSubmit" :loading="RechargeLoading">提交</el-button>
			</div>
		</el-dialog>
     
	 	<!-- 充值记录 -->
        <el-dialog :title="TitleName" v-model="dialogTableVisible" @close='closeing' >		
           <el-table :data="ShopRechargeData" highlight-current-row v-loading="logLoading">	
			<el-table-column prop="Count" label="充值数量" width="120" sortable>
			</el-table-column>
			<el-table-column prop="UnitPrice" label="充值单价" width="120" sortable>
			</el-table-column>				
			<el-table-column prop="Money" label="充值金额" width="120" sortable>
			</el-table-column>			
			<el-table-column prop="CreationTime" label="充值时间" min-width="180" sortable>
			</el-table-column>
			<el-table-column prop="Remark" label="备注" min-width="180" sortable>
			</el-table-column>
		    <el-table-column prop="State" label="记录状态"  width="120" sortable fixed="right">  
				  <template slot-scope="scope" >
                  <div slot="reference" class="name-wrapper">
                  <el-tag type="danger" size="medium" v-if="scope.row.State==0">已撤销</el-tag>
                  <el-tag type="success" size="medium" v-else>正常</el-tag>
                  </div>
                  </template>
			</el-table-column>
			<el-table-column label="操作" width="100" fixed="right">
				<template  slot-scope="scope">
					<el-button type="danger" size="small" :disabled="scope.row.State==0" @click="cancel(scope.$index, scope.row)">撤销充值</el-button>
				</template>
			</el-table-column>
           </el-table>
		   	<el-col :span="24" class="toolbar">
			<el-tag>共有{{logCount}}条充值记录</el-tag>
			<el-pagination layout="prev, pager, next" @current-change="CurrentChange" :page-size="10" :total="logCount" style="float:right;">
			</el-pagination>
	     	</el-col>
        </el-dialog>
    </section>


	
</template>
<script>
	import {ShopStatisticsList,rechargeLogPaging,CancelOrder,rechargeshop} from '../../api/api';
export default {
    data(){
        return{
            filters: {
					Name: ''
				},
				  //充值记录相关
				  TitleName:'',
				  dialogTableVisible:false,
				  ShopRechargeData:[],
				  logCount:0,
				  ShopId:0,
				  logLoading:false,
				  logPage:0,
					// 短信充值相关
				RechargeFormVisible:false,
				RechargeForm:{
					Id: 0,
					Count:1,
					Money:0,
					UnitPrice:0.1
				},
                 RechargeFormRules:{
					Count: [
						{ required: true, message: '请输入短信充值数量'},
                        { type: 'number', message: '必须为数字值'}
					],
					Money: [
						{ required: true, message: '请输入短信充值金额'},
                        { type: 'number', message: '必须为数字值'}
					],
					UnitPrice: [
						{ required: true, message: '请输入短信充值单价'},
                        { type: 'number', message: '必须为数字值'}
					],	
				 },
				 RechargeLoading:false,
                shoplist: [],
				total: 0,
				page: 0,
                listLoading: false,
                sels: [],//列表选中列
        }
    },
    methods:{
		         Count(){
			 this.RechargeForm.Money=this.RechargeForm.Count*this.RechargeForm.UnitPrice;
		 },
		 UnitPrice()
		 {
			 this.RechargeForm.Money=this.RechargeForm.Count*this.RechargeForm.UnitPrice;

		 },
				  cancel: function (index,row) {								
						this.$confirm('确认撤销吗？', '提示', {}).then(() => {
							// this.editLoading = true;
							//NProgress.start();						
							let para = Object.assign({}, row);
							CancelOrder(para).then((res) => {
								// this.editLoading = false;
								//NProgress.done();
								let { Success,Msg } = res.data;
								if(Success)
								{			
									row.State=res.data.Data.State;					
								this.$message({
									message: Msg,
									type: 'success'
								});
								}
								else
								{
									this.$message({message:Msg,type:'error'});
								}
								// this.$refs['editForm'].resetFields();								
								// this. getShop();
							});
						});									
			},

			rechargeLog:function(index,row){
				this.dialogTableVisible=true;
				this.TitleName=row.Name;
				this.ShopId=row.Id;
				this.ShopRechargeData=[];
				this.rechargeLogData();
			},
			rechargeLogData(){
				let Params = {
					PageIndex: this.logPage-1,					
					PageSize:10,
					ShopId:this.ShopId
				};			
				this.logLoading	=true;  
				  rechargeLogPaging(Params).then((res) => {
					//前端mock测试
					this.logCount = res.data.TotleCount;
					this.ShopRechargeData = res.data.Data;
					this.logLoading=false;
				})
				 .catch(error=>{
                 alert('网络错误');
                });
			},
		 editorShow(row)
	   {
		   var _this = this;
		 this.$router.push({
          name: '门店简介',
          params: {
            id: row.Id
          }
        })
	   },
			handleRecharge:function(index,row){
				this.RechargeForm={};
                this.RechargeFormVisible=true;
				this.RechargeForm=Object.assign({},row);
				this.RechargeForm.Count=1;
				this.RechargeForm.Money=0;

				this.RechargeForm.UnitPrice=0.1;
				this.RechargeForm.Money=this.RechargeForm.Count*this.RechargeForm.UnitPrice;
			},
		RechargeSubmit: function () {
				this.$refs.RechargeForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.RechargeLoading = true;
							//NProgress.start();
							let para = Object.assign({}, this.RechargeForm);
							rechargeshop(para).then((res) => {
								this.RechargeLoading = false;
								//NProgress.done();
								//NProgress.done();
								let { Success,Msg } = res.data;
					            if(Success)
						         {
                                  this.$message({
							     message: Msg,
						        	type: 'success'
						          });
						          this.getShop();
					            	}
					        	else
					         	{
                                  this.$message({
						        	message: Msg,
						        	type: 'error'
					            	});
					           	}								
								// this.$refs['editForm'].resetFields();
								this.RechargeFormVisible = false;
								this. getShop();
							});
						});
					}
				});
			},
		closeing()
		{
            this. getShop();
		},
          	handleCurrentChange(val) {
                this.page = val;
                //
				this.getShop();
			},
			CurrentChange(val)
			{
                this.logPage = val;
				this.rechargeLogData();
			},
            	//获取门店列表
			 getShop() {
				let Params = {
					Name:this.filters.shopname
				};
				this.listLoading = true;
				ShopStatisticsList(Params).then((res) => {
					this.shoplist = res.data;
					this.listLoading = false;
				})
				 .catch(error=>{
                 alert('网络错误');
                });
            },			
			selsChange: function (sels) {
				this.sels = sels;
			},
    },
    mounted() {
			this. getShop();
		}
}
</script>




// WEBPACK FOOTER //
// ShopStatistics.vue?18e0ae1f